var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.524c.833-4.167 6.667-4.652 6.667-10a6.667 6.667 0 00-13.334 0c0 5.348 5.834 5.833 6.667 10z",
    stroke: "#696969",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.024a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    stroke: "#696969",
    strokeWidth: 1.667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNiAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMDAwMDEgMTcuNTIzN0M4LjgzMzM0IDEzLjM1NzEgMTQuNjY2NyAxMi44NzIzIDE0LjY2NjcgNy41MjM3MkMxNC42NjY3IDMuODQxODIgMTEuNjgxOSAwLjg1NzA1NiA4LjAwMDAxIDAuODU3MDU2QzQuMzE4MTEgMC44NTcwNTYgMS4zMzMzNCAzLjg0MTgyIDEuMzMzMzQgNy41MjM3MkMxLjMzMzM0IDEyLjg3MjMgNy4xNjY2OCAxMy4zNTcxIDguMDAwMDEgMTcuNTIzN1oiIHN0cm9rZT0iIzY5Njk2OSIgc3Ryb2tlLXdpZHRoPSIxLjY2NjY3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMDAwMDEgMTAuMDIzN0M5LjM4MDcyIDEwLjAyMzcgMTAuNSA4LjkwNDQzIDEwLjUgNy41MjM3MkMxMC41IDYuMTQzMDEgOS4zODA3MiA1LjAyMzcyIDguMDAwMDEgNS4wMjM3MkM2LjYxOTMgNS4wMjM3MiA1LjUwMDAxIDYuMTQzMDEgNS41MDAwMSA3LjUyMzcyQzUuNTAwMDEgOC45MDQ0MyA2LjYxOTMgMTAuMDIzNyA4LjAwMDAxIDEwLjAyMzdaIiBzdHJva2U9IiM2OTY5NjkiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgLocation as ReactComponent };